import { StringComparator } from 'modules/queryBuilder/types';
import { isCatalogQueryValue } from '../../catInSeg';

export const transformCatalogCondition = <Condition extends Record<string, unknown>>({
  value,
  ...restOfCondition
}: Condition) =>
  isCatalogQueryValue(value)
    ? {
        ...restOfCondition,
        ...value,
        comparatorType: StringComparator.EQUALS,
      }
    : { value, ...restOfCondition };
